var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner loader"},[(!this.$store.state.site.content.spinner)?_c('div',{staticClass:"text-center"},[_c('br'),_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-4x",staticStyle:{"color":"LightGrey"}})]):_c('html-renderer',{attrs:{"template":`<div>${this.$store.state.site.content.spinner}</div>`,"props":'',"model":''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }